import { ActionOrTriggerListTypeEnum, IActionOrTriggerListPageParams } from "@app/static"
import { Box, Button, Grid2, Typography } from "@mui/material"
import { useRouter } from "next/router"
import { PropsWithChildren } from "react"
import { toProxy } from "@fanfanlo"
import { childToProjectDataUtils, IChildToProjectData } from "@droid/project-v2-interface"
import { actionShowFloatWindowUtils, IActionShowFloatWindowData } from "./IActionShowFloatWindow.inft"
import { useTranslation } from '@fanfanlo'

function UpdateWindowConfLink({ data, children }: { data: IActionShowFloatWindowData } & PropsWithChildren) {
    console.log('[UpdateWindowConfLink] rendering, data:', data)
    const projectInfo: IChildToProjectData = {}
    childToProjectDataUtils.actionList.getActionListByProp(data, projectInfo)
    console.log('[UpdateWindowConfLink] projectInfo:', projectInfo)

    if (!projectInfo.project?.ulid || !projectInfo.triggerActionGroup?.ulid || !projectInfo.triggerAction?.ulid || !projectInfo.actionGroup?.ulid) {
        console.error('[UpdateWindowConfLink] projectInfo is undefined', projectInfo)
        return null
    }

    const router = useRouter()
    const backPath = router.pathname
    console.log('[UpdateWindowConfLink] backPath:', backPath)

    const query: IActionOrTriggerListPageParams = {
        backPath,
        projectId: projectInfo.project?.ulid,
        triggerActionGroupId: projectInfo.triggerActionGroup?.ulid,
        triggerActionId: projectInfo.triggerAction?.ulid,
        actionGroupId: projectInfo.actionGroup?.ulid,
        type: ActionOrTriggerListTypeEnum.updateAction,
        actionId: data.ulid,
        actionType: actionShowFloatWindowUtils.type,
    }
    console.log('[UpdateWindowConfLink] query:', query)

    const param = new URLSearchParams([...Object.entries(query) as [string, string][]])
    const p = `/action-list/float-window-config?${param.toString()}`
    console.log('[UpdateWindowConfLink] path:', p)

    function onLinkClick() {
        console.log('[UpdateWindowConfLink] onClick, navigating to:', p)
        router.push(p)
    }

    return <Button
        id="show-float-window-action-change-conf-btn"
        data-id="show-float-window-action-change-conf-btn"
        data-testid="show-float-window-action-change-conf-btn-ooae882"
        onClick={onLinkClick}>
        {children}
    </Button>
}

export function IActionShowFloatWindowUI(data: IActionShowFloatWindowData) {
    const { t } = useTranslation('droid/project-v2-ext/actions/float-window/action-show-float-window/content')
    console.log('[IActionShowFloatWindowUI] rendering, data:', data)
    const windowConf = data.javaData.windowConf
    console.log('[IActionShowFloatWindowUI] windowConf:', windowConf)

    function getDisplayText(): string {
        console.log('[IActionShowFloatWindowUI.getDisplayText] calculating display text')

        if (windowConf.description && windowConf.description.trim()) {
            console.log('[IActionShowFloatWindowUI.getDisplayText] using description:', windowConf.description)
            return windowConf.description
        }

        if (windowConf.htmlConf?.url && windowConf.htmlConf.url.trim()) {
            console.log('[IActionShowFloatWindowUI.getDisplayText] using url:', windowConf.htmlConf.url)
            return windowConf.htmlConf.url
        }

        console.log('[IActionShowFloatWindowUI.getDisplayText] using windowId:', windowConf.windowId)
        return windowConf.windowId
    }


    return <Box sx={{ width: '100%' }}>
        <Box>
            <b>{t('IActionShowFloatWindow.title')}</b>
        </Box>
        <Grid2 container sx={{ width: '100%' }}>
            <Grid2 size="grow">
                <Typography sx={{}}>
                    <span style={{ display: "inline-block", textIndent: "10px" }}>
                        {getDisplayText()}
                    </span>
                </Typography>
            </Grid2>
            <Grid2 size={"auto"}>
                <UpdateWindowConfLink data={data}>
                    <span>{t('IActionShowFloatWindow.configure')}</span>
                </UpdateWindowConfLink>
            </Grid2>
        </Grid2>
    </Box>
}
